import { render, staticRenderFns } from "./cashback-grid-icon.vue?vue&type=template&id=224c142b&scoped=true&lang=pug&"
import script from "./cashback-grid-icon.vue?vue&type=script&lang=js&"
export * from "./cashback-grid-icon.vue?vue&type=script&lang=js&"
import style0 from "./cashback-grid-icon.vue?vue&type=style&index=0&id=224c142b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224c142b",
  null
  
)

export default component.exports